/**
 * @file ColorDialog.tsx
 * @description Окно «Свой цвет» (phase19.16, партия SB120; uiux-sb120-fields
 * §3): рамка диалога вокруг общего тела `ColorDialogBody`. На телефоне — на
 * весь экран, от 640 — окно 36rem. Открыто, пока `initial` не `null`; тело
 * монтируется при каждом открытии (начальный цвет — без эффектов).
 */

import type { ReactNode } from "react";

import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";
import { ColorDialogBody, type ColorDialogBodyProps } from "./ColorDialogBody";

interface Props extends Omit<ColorDialogBodyProps, "initial" | "onCancel"> {
  /** Открыто с этим цветом; `null` — закрыто. */
  initial: string | null;
  title: ReactNode;
  description: ReactNode;
  onClose: () => void;
}

export function ColorDialog({ initial, title, description, onClose, ...body }: Props) {
  return (
    <Dialog open={initial !== null} onOpenChange={(open) => (!open ? onClose() : null)}>
      <DialogContent fullScreen className="sm:max-w-xl">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        {initial !== null ? <ColorDialogBody initial={initial} onCancel={onClose} {...body} /> : null}
      </DialogContent>
    </Dialog>
  );
}
